import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import clsx from 'clsx';
import { RouterLink } from '@/components/functional/Link/RouterLink';
import { Button } from '@/components/ui/Button/Button';
import { ButtonGroup } from '@/components/ui/Button/ButtonGroup';
import { Card } from '@/components/ui/Surface/Card';
import { professionalRfpOfferPaymentPath } from '@/utils/router/links';
/**
 * コンサルタント案件確認画面 Form ボタン
 */
export const RfpProConfirmFormButton = (props) => {
    const { className = '', lockId, onClickSubmit, rfpId } = props;
    return (_jsx(Card, Object.assign({ className: clsx('flex items-center justify-center', 'px-24 py-16 sm:px-16', className) }, { children: _jsxs(ButtonGroup, Object.assign({ className: 'w-[306px] sm:w-[416px]' }, { children: [_jsx(RouterLink, Object.assign({ className: 'inline-block w-full', state: { lockId }, to: professionalRfpOfferPaymentPath(rfpId) }, { children: _jsx(Button, Object.assign({ color: 'gray', isFull: true, size: 'md' }, { children: "\u524D\u306B\u623B\u308B" })) })), _jsx(Button, Object.assign({ color: 'orange', isFull: true, onClick: onClickSubmit, size: 'md' }, { children: "\u63D0\u6848\u3092\u63D0\u51FA\u3059\u308B" }))] })) })));
};
